import ApiService from '@/api';

export class AdapterService {
  private readonly api = new ApiService();

  /**Функция обработчик при остановке таймера */
  onStopTimerEvent = () => {
    return this.api.Main.TaskTimersService.OnStopTimerEvent;
  };
  /**Функция обработчик при старте таймера */
  onStartTimerEvent = () => {
    return this.api.Main.TaskTimersService.OnStartTimerEvent;
  };
}
